import { path } from 'ramda';

import { ApplicationType } from 'models/application/Application';

export const getRouterLocationState = (state: any) =>
    path<Record<string, any>>(['router', 'location', 'state'], state);

export const getQuoteTypeFromRouterState = (state: any) =>
    path<ApplicationType>(['router', 'location', 'state', 'quoteType'], state);
